import styled from 'styled-components'
import COLORS from '@colors'

export const Container = styled.div`
  max-width: 100%;
  position: relative;
`

export const Button = styled.button`
  align-items: center;
  font-weight: bold;
  text-align: left;
  font-family: 'Barlow';
  background-color: ${COLORS.whiteF3};
  border: 0;
  border-radius: 4px;
  color: ${COLORS.gray45};
  display: flex;
  height: 32px;
  padding: 10px 10px;
  width: 100%;
  cursor: pointer;
  outline: 0;
`
export const Label = styled.div`
  line-height: 14px;
  max-height: 14px;
  max-width: calc(100% - 9px);
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 9px);
`

export const OptionContainer = styled.div`
  background-color: ${COLORS.white};
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
  max-height: 280px;
  max-width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  z-index: 3;
`

export const Input = styled.input`
  border: 0;
  border-bottom: 1px solid ${COLORS.grayE1};
  outline: none;
  padding: 8px;
  width: 100%;
`

export const ScrollContainer = styled.div`
  max-height: 150px;
  overflow-y: auto;
  padding: 0 12px;

  div {
    color: ${COLORS.gray45};
    cursor: pointer;
    height: 32px;
    margin-left: -12px;
    margin-right: -12px;
    padding: 8px;
  }

  div:hover,
  div:focus {
    background-color: #f9f7f1;
    outline: 0;
  }
`
